// extracted by mini-css-extract-plugin
export default {"formCard":"styles_formCard__9cVJc","showFormCard":"styles_showFormCard__WNq1U","hideFormCard":"styles_hideFormCard__NmShk"};